module.exports = "<app-privacy-heading></app-privacy-heading>\n<app-footer></app-footer>\n"